module.exports = __webpack_public_path__ + "static/media/scotia-vida-ico-beneficiario-gris.bc464e15.svg";